// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// element-ui按需引入
import "@/element";
import "element-ui/lib/theme-chalk/index.css";
import App from './App'
import router from './router'
import './assets/public.less'
import store from './store/index';
import LoadingView from './views/loading.vue'
import bannerCom from "./components/banner";
import skeleton from "./components/skeleton";
import axios from 'axios'
import http from './api'
Vue.config.productionTip = false//屏蔽（console）提示
Vue.prototype.$http = http
Vue.component("loadingView", LoadingView);
Vue.component("bannerCom", bannerCom);
Vue.component("skeleton", skeleton);
router.beforeEach((to, from, next) => {
    if (localStorage.getItem('token') && store.state.count) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      store.commit('updateCount',true)
       http.getToken().then(data => {
        if(data){
          localStorage.setItem('token', data.access_token)
          next();
        }
      })
    }
});
/* eslint-disable no-new */
// 使用配置文件设置生产环境请求地址
let startApp = function () {
let url = process.env.NODE_ENV === "development"?'/static/config.json':'/website/static/config.json'
  axios.get(url).then((res) => {
    // 基础地址
    Vue.prototype.BASE_URL = res.data.BASE_URL;
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  })
}

startApp()


// WEBPACK FOOTER //
// ./src/main.js